import { getPublicPath } from '@/api/utils/tool'
export let defaultBarcodeRule = {
  'format': 'CODE128B', // barcode protocol
  'background': '#FFFFFF',
  'lineColor': '#000000',
  'fontSize': 15,
  'height': 40,
  'width': 1,
  'margin': 10,
  'textMargin': 0,
  'displayValue': false, // display barcodeNo
  'font': 'monospace',
  'fontOptions': '',
  'textAlign': 'center', // display barcodeNo center by barcode graph
  'img_width': '', // 控制条码显示的宽度，默认为空，不控制
  'img_height': '', // 控制条码显示的高度，默认为空，不控制
}

const staticPath = getPublicPath()
// 打印模板
export const INNER_LABEL_PATH = staticPath + 'static/template/label.ejs'
export const OUTBOUND_PACK_PATH = staticPath + 'static/template/pack.ejs' //京东面单模板
export const OUTBOUND_ECLP_EXTERNAL_ORDER_PACK_PATH = staticPath + 'static/template/eclpExternalOrderPack.ejs' //ECLP外单面单模板
export const OUTBOUND_3PL_PACK_PATH = staticPath + 'static/template/3plPack.ejs' //3PL面单模板
export const SUPPLIER_PATH = staticPath + 'static/template/supplier.ejs'
export const INBOUND_BAR_CODE_PATH = staticPath + 'static/template/inbound/skuBarCode.ejs'
export const HANDOER_PATH = staticPath + 'static/template/inbound/handoer.ejs'
export const OUTBOUND_BACK_TO_OWNER_PATH = staticPath + 'static/template/outbound/box_lable_for_backing_to_owner.ejs'
export const CONTAINER_NUMBER = staticPath + 'static/template/container_number.ejs'
export const STORAGE_LOCATION_NUMBER = staticPath + 'static/template/storage_location_number.ejs'
// 预检单中文版
export const INBOUND_PRE_INSPECTION_SHEET = staticPath + 'static/template/inbound/A1025_Pre_Inspection.ejs'
// 预检单英文版
export const INBOUND_PRE_INSPECTION_SHEET_EN = staticPath + 'static/template/inbound/Pre_Inspection_EN.ejs'
export const INBOUND_PRE_INSPECTION_SHEET_US = staticPath + 'static/template/inbound/Pre_Inspection_EN_US.ejs'
// 验收单中文版
export const INBOUND_ACCEPTANCE_SHEET = staticPath + 'static/template/inbound/A1026_Acceptance.ejs'
// 验收单英文版
export const INBOUND_ACCEPTANCE_SHEET_EN = staticPath + 'static/template/inbound/Inspection_Sheet_EN.ejs'
export const INBOUND_ACCEPTANCE_SHEET_US = staticPath + 'static/template/inbound/Inspection_Sheet_US.ejs'
//LPN验收托唛模板
export const INBOUND_ACCEPTANCE_SHEET_LPN = staticPath + 'static/template/inbound/A1028_Shipping_Mark.ejs'
//非LPN验收托唛模板
export const INBOUND_ACCEPTANCE_SHEET_NOT_LPN = staticPath + 'static/template/inbound/A1029_Shipping_Mark.ejs'
export const INBOUND_BOX_SKU_BARCODE = staticPath + 'static/template/inbound/box_sku_barcode.ejs'

//wangzhi insert b2b复核打包 begin
export const BOX_DETAILED_PATH = staticPath + 'static/template/outbound/crossBorder/A1010_Box_Detailed.ejs'
export const PALLET_DETAILED_PATH = staticPath + 'static/template/outbound/crossBorder/A1013_Pallet_Detailed.ejs'
export const PALLET_LIST_PATH = staticPath + 'static/template/outbound/crossBorder/A1011_Pallet_List.ejs'
export const HANDOVER_PATH = staticPath + 'static/template/outbound/crossBorder/A1012_Handover.ejs'
export const ABROAD_WAREHOUSE_ORDER_LABEL = staticPath + 'static/template/outbound/A1030_Abroad_Label.ejs'
export const INDONESIAN_ORDER_LABEL = staticPath + 'static/template/outbound/A10131_Indonesia.ejs'
export const OUTBOUND_COMMON_PACKINGLIST = staticPath + 'static/template/outbound/public_packingList.ejs'

export const NP_PACKINGLIST_PATH = staticPath + 'static/template/supplier.ejs'

//打印机设置
export const BOX_DETAILED = 'boxDetailed' //箱明细
export const PALLET_DETAILED = 'palletDetailed' //板签
export const PALLET_LIST = 'palletList' //板明细
export const HANDOVER = 'habdover' //交接单
export const INBOUND_ACCEPTANCE_LPN ='lpnAcceptance' // LPN面单
export const INBOUND_ACCEPTANCE_NOT_LPN ='notLpnAcceptance' //非LPN面单
export const BOX_SKU_BARCODE = 'boxSkuBarcode'
export const OUTBOUND_COMMON_PACKINGLIST_DOC = 'outbound_common_packingList' //出库通用箱单packinglist
//end
// 打印机设置
export const PRINT_PRE_CHECK = 'precheck_zh' //预检单
export const PRINT_PRE_CHECK_EN = 'precheck_en' //预检单
export const PRINT_PRE_CHECK_US = 'precheck_us' //预检单
export const PRINT_ACCEPT_DOC = 'acceptDoc_zh' //验收单
export const PRINT_ACCEPT_DOC_EN = 'acceptDoc_en' //验收单
export const PRINT_ACCEPT_DOC_US = 'acceptDoc_us' //验收单
export const PRINT_IN_TRANS_DELIVEY = 'inTransDelivey' //内配发货交接单
export const PRINT_IN_TRANS_ACCEPT = 'inTransAccept' //内配验收交接单
export const PRINT_INVENTORY = 'inventory' //盘点打印
export const PRINT_DELIVERY_NOTE = 'deliveryNote' //配送交接单打印
export const PRINT_RETURN_EIRLIST = 'returnEirList' //退货拒收交接单
export const PRINT_BATCH = 'batch' //集合单
export const PRINT_TASK = 'task' //任务单
export const PRINT_PACKAGE_NO = 'packageNo' //打包序号
export const PRINT_PRECHECK_LABEL = 'precheckLabel' //预检标签
export const PRINT_IN_TRANSPORT_LABEL = 'inTransportLabel' //内配单标签
export const PRINT_SKU_BARCODE = 'skuBarcode' //sku码，自编码标签
export const PRINT_CONTAINER = 'Container' //公共容器标签
export const PRINT_PICKING_ORDER = 'pickingOrder' //PC纸质拣选
export const PRINT_ORDER = 'order' //面单
export const PRINT_INVOICE = 'invoice' //发票
export const PRINT_PAPERLESS_PACKAGE = 'paperlessPackage' //无纸化包裹标签
export const PRINT_GREETING_CARD = 'greetingCard' //贺卡
export const PRINT_ORDER_LIST = 'orderList' //购物清单
export const PRINT_PAPER_PURCHASE = 'paperPurchase' //商采三联单
export const PRINT_SAMPLE_BOXLABLE = 'sampleboxlable' //样品箱签
export const PRINT_OUTBOUND_SHIP = 'outBoundShip' //退供应商、赠品、大库出备件库箱签
export const PRINT_BACK_TO_OWNER_BOX_M = 'backToOwnerBoxM' //退供应商、赠品箱明细
export const PRINT_MEDICINE_ORDER_LIST = 'medicineOrderList' //医药随货同行单
export const PRINT_SAMPLEHAN_DOVER = 'samplehandover' //样品交接单
export const PRINT_SPARE_STORE = 'spareStore' //备件库交接单
export const PRINT_SUPPLIER = 'supplier' //退供应商交接单
export const PRINT_PACK_MODEL = 'packmodel' //内配复核打印
export const PRINT_HANDOER = 'handoverlist'//商家验收单
export const PRINT_STORAGE_LOCATION = 'storageLocation' //储位标签
export const PRINT_NP_PACKING_LIST = 'npPackingListLabel' //储位标签

export const CLOUD_PRINT_BASIC_INFO = {
  TEMPLATE_ID: {
    COMMON_ORDER_ID: 1
  },
  TEMPLATE: [{
    id: 1,
    sys: 'WMS_i18n',
    countryFlag: 'COMMON',
    type: 'ORDER',
    name: 'A1002N', //订单面单
    version: '1',
    note: '订单面单'
  },{
    id: 2,
    sys: 'WMS_i18n',
    countryFlag: 'COMMON',
    type: 'SKU',
    name: 'A1021', //SKU条码
    version: '1',
    note: 'SKU条码'
  },{
    id: 3,
    sys: 'WMS_i18n',
    countryFlag: 'COMMON',
    type: 'RECEIVING',
    name: 'P001N', //商家验收单
    version: '1',
    note: '商家验收单'
  },{
    id: 4,
    sys: 'WMS_i18n',
    countryFlag: 'COMMON',
    type: 'RTS',
    name: 'A10231', //退供应商交接单
    version: '1',
    note: '退供应商交接单'
  },{
    id: 5,
    sys: 'WMS_i18n',
    countryFlag: 'COMMON',
    type: 'RTS',
    name: 'outBoundShipN', //退供箱签
    version: '1',
    note: '退供箱签'
  },{
    id: 6,
    sys: 'WMS_i18n',
    countryFlag: 'COMMON',
    type: 'RTS',
    name: 'A1010', //箱明细
    version: '1',
    note: '箱明细'
  },{
    id: 7,
    sys: 'WMS_i18n',
    countryFlag: 'COMMON',
    type: 'RTS',
    name: 'A1013', //板签
    version: '1',
    note: '板签'
  },{
    id: 8,
    sys: 'WMS_i18n',
    countryFlag: 'COMMON',
    type: 'RTS',
    name: 'A1011', //板明细
    version: '1',
    note: '板明细'
  },{
    id: 9,
    sys: 'WMS_i18n',
    countryFlag: 'COMMON',
    type: 'RTS',
    name: 'A1012', //交接单
    version: '4',
    note: '交接单'
  },
  {
    id: 10,
    sys: 'WMS_i18n',
    name: 'A1014', //发票
    version: '7',
    note: '发票'
  },{
    id: 11,
    sys: 'WMS_i18n',
    name: 'A1015', //客退
    version: '5',
    note: '客退'
  },{
    id: 12,
    sys: 'WMS_i18n',
    name: 'A1016', //箱单
    version: '2',
    note: '箱单'
  },{
    id: 13,
    sys: 'WMS_i18n',
    name: 'A1025_Pre_Inspection', //预检单
    version: '9',
    note: '预检单'
  },{
    id: 14,
    sys: 'WMS_i18n',
    name: 'A1026_Acceptance', //验收单
    version: '3',
    note: '验收单'
  },{
    id: 15,
    sys: 'WMS_i18n',
    name: 'A1020', //新订单面单
    version: '2',
    note: '新订单面单'
  },{
    id: 16,
    sys: 'WMS_i18n',
    name: 'A1028_Shipping_Mark', //LPN面单
    version: '1',
    note: 'LPN面单'
  },{
    id: 17,
    sys: 'WMS_i18n',
    name: 'A1029_Shipping_Mark', //非LPN面单
    version: '1',
    note: '非LPN面单'
  },{
    id: 18,
    sys: 'WMS_i18n',
    name: 'A1030_Abroad_Label', //德国等海外仓面单
    version: '5',
    note: '德国等海外仓面单'
  },{
    id: 19,
    sys: 'WMS_i18n',
    name: 'A10131_Indonesia', //印尼面单
    version: '7',
    note: '印尼面单'
  },{
    id: 20,
    sys: 'WMS_i18n',
    name: 'box_sku_barcode', //箱条码
    version: '1',
    note: '箱条码'
  },{
      id: 21,
      sys: 'WMS_i18n',
      name: 'Pre_Inspection_EN', //预检单EN
      version: '6',
      note: '预检单EN'
    },{
      id: 22,
      sys: 'WMS_i18n',
      name: 'Inspection_Sheet_EN', //验收单EN
      version: '6',
      note: '验收单EN'
    },{
      id: 23,
      sys: 'WMS_i18n',
      name: 'Pre_Inspection_EN_US', //预检单EN_US
      version: '3',
      note: '预检单EN_US'
    },{
      id: 24,
      sys: 'WMS_i18n',
      name: 'Inspection_Sheet_US', //验收单EN_US
      version: '4',
      note: '验收单EN_US'
    },{
      id: 25,
      sys: 'WMS_i18n',
      name: 'public_packingList', //通用箱单packinglist
      version: '3',
      note: '通用箱单packingList'
    },{
      id: 26,
      sys: 'WMS_i18n',
      name: 'mca_selfPickUp_label', // MCA人工自提纯仓新面单
      version: '11',
      note: 'MCA人工自提纯仓新面单'
    },{
      id: 27,
      sys: 'WMS_i18n',
      name: 'au_envelope', //澳洲信封，简易面单
      version: '2',
      note: '澳洲信封，简易面单'
    },
    {
      id: 28,
      sys: 'WMS_i18n',
      name: 'endcothing_goods', // endclothing商品标签
      version: '4',
      note: 'endclothing商品标签'
    },
    {
      id: 35,
      sys: 'WMS_i18n',
      name: 'hkm_cc_package_label', // hkm_cc_package_label CC包裹打印
      version: '9',
      note: 'CC包裹打印'
    },
    {
      id: 101,
      sys: 'WMS_i18n',
      name: 'public_A4_horizontal', // 通用A4模板-横板
      version: '8',
      note: '通用A4模板-横板'
    },{
      id: 29,
      sys: 'WMS_i18n',
      name: 'large_pickList_sort', // 大件按储位维度排序
      version: '14',
      note: '大件按储位维度排序'
    },{
      id: 30,
      sys: 'WMS_i18n',
      name: 'largeGoods_pickList', // 大件按订单维度排序
      version: '14',
      note: '大件按订单维度排序'
    },{
      id: 31,
      sys: 'WMS_i18n',
      name: 'inboundNo_labels', // 维保标签
      version: '1',
      note: '入库单标签'
    },{
      id: 32,
      sys: 'WMS_i18n',
      name: 'maintenance_abel', // 维保面签，面单已拆分为两个，这个不再使用
      version: '2',
      note: '维保面签(废)'
    },{
      id: 34,
      sys: 'WMS_i18n',
      name: 'callOrder_failedInfo', // 占位面单
      version: '1',
      note: '占位面单'
    },{
      id: 36,
      sys: 'WMS_i18n',
      name: 'picking_task_list', // 拣货任务单标签
      version: '3',
      note: '拣货任务单标签'
    },
    {
      id: 37,
      sys: 'WMS_i18n',
      name: 'KK_Customer_label', // KK客单面单
      version: '10',
      note: 'KK客单面单'
    },
    {
      id: 38,
      sys: 'WMS_i18n',
      name: 'invop_shipping_mark', // 在库LPN托唛模板
      version: '1',
      note: '在库LPN托唛模板'
    },
    {
      id: 39,
      sys: 'WMS_i18n',
      name: 'casual_pallet_label', // 临时托唛
      version: '5',
      note: '临时托唛'
    },
    {
      id: 40,
      sys: 'WMS_i18n',
      name: 'handover_details', // 交接商品明细_EN
      version: '9',
      note: '交接商品明细_EN'
    },
    {
      id: 41,
      sys: 'WMS_i18n',
      name: 'handover_details_pl', // 交接商品明细_PL
      version: '5',
      note: '交接商品明细_PL'
    },
    {
      id: 42,
      sys: 'WMS_i18n',
      name: 'ups_shipping_paper', // ups_shippint_paper
      version: '1',
      note: 'ups_shipping_paper'
    },
    {
      id: 43,
      sys: 'WMS_i18n',
      name: 'maintenance_mark', // 维保标签_标识
      version: '1',
      note: '维保标签_标识'
    },
    {
      id: 44,
      sys: 'WMS_i18n',
      name: 'maintenance_taskNo', // 维保标签_任务号
      version: '1',
      note: '维保标签_任务号'
    },
    {
      id: 45,
      sys: 'WMS_i18n',
      name: 'pdf_facesheet', // PDF云打印模板
      version: '1'
    },
    {
      id: 46,
      sys: 'WMS_i18n',
      name: 'relocation_pre', // 搬仓预检单
      version: '1'
    },
    {
      id: 47,
      sys: 'WMS_i18n',
      name: 'mca_delivery_label',
      version: '6',
      note: 'MCA配送转自提新面单'
    },
    {
      id: 48,
      sys: 'WMS_i18n',
      name: 'mca_locker_pickup_label',
      version: '3',
      note: 'MCA自提柜面单'
    },
    {
      id: 49,
      sys: 'WMS_i18n',
      name: 'paper_pick_cell_en', // 29
      version: '3',
      note: '纸单拣货单_储位排序_英文版本'
    },
    {
      id: 50,
      sys: 'WMS_i18n',
      name: 'paper_pick_order_en', // 30
      version: '2',
      note: '纸单拣货单_订单排序_英文版本'
    },
    {
      id: 51,
      sys: 'WMS_i18n',
      name: 'mca_self_delivery',
      version: '2',
      note: 'MCA自营配送面单'
    },
    {
      id: 52,
      sys: 'WMS_i18n',
      name: 'mca_transfer_out',
      version: '5',
      note: 'MCA调拨出库面单'
    },
    {
      id: 53,
      sys: 'WMS_i18n',
      name: 'self_pickup_common',
      version: '3',
      note: 'MCA自提通用模板'
    },
    {
      id: 54,
      sys: 'WMS_i18n',
      name: 'P1001',
      version: '20',
      note: '纸质拣货单任务单通用模板'
    },
    {
      id: 55,
      sys: 'WMS_i18n',
      name: 'pick_order_hisense',
      version: '2',
      note: '纸质拣货单任务单(派车单)'
    },
    {
      id: 56,
      sys: 'WMS_i18n',
      name: 'delivery_label_hisense',
      version: '1',
      note: '分货单'
    },
    {
      id: 57,
      sys: 'WMS_i18n',
      name: 'vas_instruction_lb',
      version: '3',
      note: 'vas烫金刻字'
    },
    {
      id: 58,
      sys: 'WMS_i18n',
      name: 'png1002', // PNG云打印模板
      version: '4'
    },
    {
      id: 59,
      sys: 'WMS_i18n',
      name: 'inbound_label_fop',
      version: '3',
      note: '打印商品标签'
    },
    {
      id: 60,
      sys: 'WMS_i18n',
      name: 'gift_card_pro1',
      version: '9',
      note: '礼品卡模版'
    },
    {
      id: 62,
      sys: 'WMS_i18n',
      name: 'hot1001',
      version: '3',
      note: '爆品清单'
    },
    {
      id: 61,
      sys: 'WMS_i18n',
      name: 'vas_print_model_new',
      version: '2',
      note: 'vas打印'
    },
    {
      id: 63,
      sys: 'WMS_i18n',
      name: 'mca_one_part_delivery',
      version: '1',
      note: 'MCA-1PL配送面单'
    },
    {
      id: 64,
      sys: 'WMS_i18n',
      name: 'box_sku_info',
      version: '8',
      note: 'sku信息的箱标'
    },
    {
      id: 65,
      sys: 'WMS_i18n',
      name: 'vas_lb_new',
      version: '6',
      note: 'vas烫金刻字-新版'
    },
    {
      id: 66,
      sys: 'WMS_i18n',
      name: 's_container_label',
      version: '7',
      note: '容器打印(规格)'
    },
    {
      id: 67,
      sys: 'WMS_i18n',
      name: 'goods_image',
      version: '3',
      note: '法国迪卡侬商品标签'
    },
    {
      id: 68,
      sys: 'WMS_i18n',
      name: 'png1001', // base64云打印模板
      version: '2',
      note: 'base64云打印模板'
    },
    {
      id: 69,
      sys: 'WMS_i18n',
      name: 'ukjdkd100x150', // 英国起网云打印模版
      version: '7',
      note: '英国起网云打印模版'
    },
    {
      id: 70,
      sys: 'WMS_i18n',
      name: 'otto_label_70x200', // otto label
      version: '1',
      note: 'otto label模板'
    },
    {
      id: 71,
      sys: 'WMS_i18n',
      name: 'sitepng002', // 作业区二维码打印模版
      version: '5', // 18 * 18
      note: '作业区二维码打印模版'
    },
    {
      id: 72,
      sys: 'WMS_i18n',
      name: 'fn_sku_label', // 子不语FNSku模板
      version: '5',
      note: '子不语FNSku模板'
    },
    {
      id: 73,
      sys: 'WMS_i18n',
      name: 'transparent_plan_code_label', // 子不语透明码模板
      version: '5',
      note: '子不语透明码模板',
    },
    {
      id: 74,
      sys: 'WMS_i18n',
      name: 'fbaTmpShippingMark', // 临时箱唛
      version: '3',
      note: '临时箱唛',
    },
    {
      id: 75,
      sys: 'WMS_i18n',
      name: 'fba_delivery_note', // 打印fab物流交接单
      version: '5',
      note: '打印fab物流交接单',
    },
    {
      id: 76,
      sys: 'WMS_i18n',
      name: 'sitepng002', // 作业区二维码打印模版
      version: '6', // 15 * 15
      note: '作业区二维码打印模版'
    },
    {
      id: 77,
      sys: 'WMS_i18n',
      name: 'Big_package_delivery', // 广西TT边境仓大小件面单
      version: '5',
      note: '作业区二维码打印模版'
    },
    {
      id: 78,
      sys: 'WMS_i18n',
      name: 'np_packinglist_label', // 调拨单packingList
      version: '3',
      note: '调拨单箱单'
    },
    {
      id: 79,
      sys: 'WMS_i18n',
      name: 'hanshuoPackingList', // 汉朔packingList
      version: '2',
      note: '汉朔箱单'
    },{
      id: 81,
      sys: 'WMS_i18n',
      name: 'xiaopeng_di', // 小鹏DA-订单维度
      version: '2',
      note: '小鹏DA-订单维度'
    },
    {
      id: 82,
      sys: 'WMS_i18n',
      name: 'xiaopeng_ci', // 小鹏CI-订单维度
      version: '2',
      note: '小鹏CI-订单维度'
    },
    {
      id: 83,
      sys: 'WMS_i18n',
      name: 'xp_pl_order_template_new', // 小鹏PL-订单维度
      version: '1',
      note: '小鹏PL-订单维度'
    },
    {
      id: 84,
      sys: 'WMS_i18n',
      name: 'xp_pl_package_template', // 小鹏PL-包裹维度
      version: '1',
      note: '小鹏PL-包裹维度'
    },
    {
      id: 85,
      sys: 'WMS_i18n',
      name: 'xp_pl_pallet_template', // 小鹏PL-托维度
      version: '1',
      note: '小鹏PL-托维度'
    },
    {
      id: 86,
      sys: 'WMS_i18n',
      name: 'A5080', // 日本发航空件-按SPP打印特殊标签
      version: '1',
      note: '日本发航空件-按SPP打印特殊标签'
    },
    {
      id: 87,
      sys: 'WMS_i18n',
      name: 'sailisi003', // 赛力斯二维码打印模版
      version: '1',
      note: '赛力斯二维码打印模版'
    },
    {
      id: 88,
      sys: 'WMS_i18n',
      name: 'WordCard', // 员工工号打印模版
      version: '5',
      note: '员工工号打印模版'
    }, 
    {
      id: 89,
      sys: 'WMS_i18n',
      name: 'vas_gift_card_pro', // "增值服务_礼品卡
      version: '1',
      note: '增值服务_礼品卡_面单打印机'
    },
     {
      id: 90,
      sys: 'WMS_i18n',
      name: 'vas_gift_card_plain', // "增值服务_礼品卡
      version: '1',
      note: '增值服务_礼品卡_A4喷墨打印机'
    },
    {
      id: 91,
      sys: 'WMS_i18n',
      name: 'Transfer_Order_CMR', // 调拨单CMR
      version: '1',
      note: '调拨单CMR'
    },
    {
      id: 92,
      sys: 'WMS_i18n',
      name: 'vas_kit_label_print',
      version: '1',
      note: 'vas增值服务-组套'
    },
    {
      id: 93,
      sys: 'WMS_i18n',
      name: 'ecec_picking_list', // 企配中心拣货单
      version: '9',
      note: '企配中心拣货单'
    }
  ]
}

/**
 * 定义打印方式，由此值控制打印方式
 * @type {string}
 */
export const DEFINE_PRINT_WAY = 'cloud';

export const PRINT_WAY = {
  CLOUD_PRINT: 'cloud', //云打印
  ELECTRON_PRINT: 'electron' //ELECTRON方式打印
}

export const PRINT_TYPE_3PL = {
  ORDER: 1, // 订单维度
  PACKAGE: 2, // 包裹维度
  PALLET: 4 // 托维度
}
/**
 * 打印方式
 */
export const PRINT_METHOD = {
  Multiple: 'Multiple', // 按包裹分多次打印
  Onetime: 'One-time' // 整单一次性打印
}
